import  {Caps}  from "./prod";
import  {uploadPackage}  from "./proddata";
import  {leftResource,userDetail,deleteUser,hqjsbfylist,hqjsxqdetail,Deledelete,getBindMenu,fdqyhresource,deleteMenuShip,
specificationCate,deleteSpecCate,specificationsDetail,deleteSpecificationValue,deleteication,partsList,deletePartCate,deleteParts,
deletepartDetail,deletePartsVariants,ydyscqueryDetail,ydydelete,hqggxqdetail,ggdelete,deleteCate,cplbdetail,queryCateType,
pjcslbpartsList,queryPartsList,hbxqdetail,hbscdelete,deleteCarousel,hqlbtxqdetail,orderDetail,dddelete,hqsyxxindex,placeorder,
xssjsaleCate,expurgate,queryProductParts,hqcpxqdetail,sccphpjexpurgate,xjcpxqdetail,xjpjxqpartDetail,expurgateProductVariants,queryCascadeParts,
ycremoveImage,pjycremoveImage,scwjremoveFile,xlhqhqueryUser,hqssqlist,deleteRegional,hqywqyxqdetail,selectUnReadMessage}  from "./xwwwprod";
import  {Login,hqyhlist,yhzcregister,updateUser,czmmresetPwd,bindRole,hqjslbfypage,tjjsxxadd,xgjsxxupdate,ydyqueryPage,downParts,
   addMenuShip,gglbyationsPage,operatorSpe,pltjggadd,updateBatchSpecifications,operatorPartsCate,queryPartsPage,cplbqueryPage,
   tjpjaddParts,updateParts,operatorGuidance,operatorSubject,gglbqueryPage,queryPagelist,queryProduct,hbxzxgoperatorPoster,operatorCate,
   lbtlbqueryPage,cxcplbqueryPage,specificationList,tjcplbadd,cplbbfyqueryList,bdpjbindParts,AddCarousel,updateCarousel,cxddlbqueryPage,
   tjfkaddFeedback,switchCarousel,downProduct,modifyProductParts,xgcpxxmodify,querySoldOutPage,plsjupGoodsBatch,gxpjupdateParts,downProductVariants,
   lfjllbqueryPage,pjdownProductVariants,cxqyjlqueryPage,tjquyjaddRegional,editRegional,gxupdateStatus
}  from "./utfprod";
export default{
   leftResource,
   Caps,
   Login,
   hqyhlist,
   uploadPackage,
   yhzcregister,
   userDetail,
   updateUser,
   deleteUser,
   czmmresetPwd,
   hqjsbfylist,
   bindRole,
   hqjslbfypage,
   tjjsxxadd,
   hqjsxqdetail,
   xgjsxxupdate,
   Deledelete,
   getBindMenu,
   fdqyhresource,
   addMenuShip,
   deleteMenuShip,
   specificationCate,
   gglbyationsPage,
   operatorSpe,
   deleteSpecCate,
   pltjggadd,
   specificationsDetail,
   deleteSpecificationValue,
   updateBatchSpecifications,
   deleteication,
   operatorPartsCate,
   partsList,
   deletePartCate,
   queryPartsPage,
   tjpjaddParts,
   deleteParts,
   deletepartDetail,
   deletePartsVariants,
   updateParts,
   ydyqueryPage,
   operatorGuidance,
   ydyscqueryDetail,
   ydydelete,
   operatorSubject,
   gglbqueryPage,
   hqggxqdetail,
   ggdelete,
   queryPagelist,
   queryProduct,
   hbxzxgoperatorPoster,
   cplbqueryPage,
   operatorCate,
   deleteCate,
   cplbdetail,
   downParts,
   lbtlbqueryPage,
   cxcplbqueryPage,
   specificationList,
   tjcplbadd,
   queryCateType,
   pjcslbpartsList,
   queryPartsList,
   cplbbfyqueryList,
   bdpjbindParts,
   hbxqdetail,
   hbscdelete,
   AddCarousel,
   deleteCarousel,
   hqlbtxqdetail,
   updateCarousel,
   cxddlbqueryPage,
   orderDetail,
   tjfkaddFeedback,
   dddelete,
   hqsyxxindex,
   placeorder,
   xssjsaleCate,
   switchCarousel,
   downProduct,
   expurgate,
   queryProductParts,
   modifyProductParts,
   hqcpxqdetail,
   xgcpxxmodify,
   querySoldOutPage,
   sccphpjexpurgate,
   plsjupGoodsBatch,
   xjcpxqdetail,
   xjpjxqpartDetail,
   gxpjupdateParts,
   downProductVariants,
   expurgateProductVariants,
   lfjllbqueryPage,
   queryCascadeParts,
   ycremoveImage,
   pjycremoveImage,
   pjdownProductVariants,
   scwjremoveFile,
   cxqyjlqueryPage,
   xlhqhqueryUser,
   hqssqlist,
   tjquyjaddRegional,
   deleteRegional,
   hqywqyxqdetail,
   editRegional,
   selectUnReadMessage,
   gxupdateStatus
}


// WEBPACK FOOTER //
// ./src/api/index.js